import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IConnectedApplicationType } from '../types/ConnectedApplicationType';


function CreateConnectedApplicationConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'POST',
    endpoint: 'connected-applications/',
    serverWideRequest: false
  };
}

// Until it is created, a Connected Application has neither an ID/ClientId nor a createdAt time
export type CreateConnectedApplicationType = Omit<IConnectedApplicationType, 'clientId' | 'createdAt'>;
export interface CreateConnectedApplicationParams {
  connectedApplication: CreateConnectedApplicationType;
}

export interface CreateConnectedApplicationResult {
  error?: unknown;
  connectedApplication?: IConnectedApplicationType;
}

export function callCreateConnectedApplication(request: CreateConnectedApplicationParams): Promise<CreateConnectedApplicationResult> {
  return makeJsonRestApiRequest<CreateConnectedApplicationParams, CreateConnectedApplicationResult>({
    config: CreateConnectedApplicationConfig(),
    request,
  });
}